module.exports = __webpack_public_path__ + "static/logo-footer-resized-0b9a8b37c98376880fe5edb621d42bfe.png";